import { useTheme } from "@hooks";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.background,
      width: "100%",
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  };

  return styles;
};
